module.exports = __webpack_public_path__ + "static/media/29ADMSPC31.da30a39b.jpg";